import React from "react";
import {
  Home,
  GraduationCap,
  Stethoscope,
  Car,
  RefreshCw,
  Briefcase,
  Plane,
  Sparkles,
} from "lucide-react";

const usos = [
  { icon: RefreshCw, title: "Refinanciamiento y consolidación de deudas", desc: "Reúne tus créditos en uno solo y compara ofertas con mejor CAE." },
  { icon: Home, title: "Créditos para remodelación del hogar", desc: "Financia reparaciones, ampliaciones o mejoras de tu vivienda." },
  { icon: Car, title: "Crédito automotriz y mantención de vehículos", desc: "Compara préstamos personales para compra o reparación de tu auto." },
  { icon: GraduationCap, title: "Crédito para estudios y capacitación", desc: "Financia carreras, diplomados o cursos técnicos en Chile." },
  { icon: Stethoscope, title: "Gastos médicos y de salud", desc: "Cubre tratamientos, intervenciones o emergencias médicas." },
  { icon: Briefcase, title: "Capital para emprendedores", desc: "Accede a préstamos personales para impulsar tu negocio o Pyme." },
  { icon: Plane, title: "Viajes y proyectos personales", desc: "Compara créditos de libre disposición para tus metas." },
  { icon: Sparkles, title: "Crédito de libre consumo", desc: "Un préstamo personal online flexible para lo que necesites." },
];

export default function CreditUses() {
  return (
    <section
      className="py-20 lg:py-28 bg-white"
      data-testid="credit-uses-section"
      aria-labelledby="usos-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Usos frecuentes
          </span>
          <h2
            id="usos-heading"
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
          >
            Créditos de consumo y préstamos personales online para cada meta
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Con Bancoorp puedes comparar opciones de crédito de libre disposición
            para distintos proyectos. Las entidades financieras aliadas evalúan
            tu solicitud de forma independiente.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {usos.map((u, i) => (
            <article
              key={i}
              className="rounded-2xl bg-slate-50 border border-slate-200 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:border-blue-200"
              data-testid={`uso-${i}`}
            >
              <div className="h-10 w-10 rounded-lg bg-blue-600 text-white flex items-center justify-center mb-4">
                <u.icon className="h-5 w-5" strokeWidth={2} />
              </div>
              <h3 className="text-base font-semibold text-slate-900 leading-tight">
                {u.title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {u.desc}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs text-slate-500 leading-relaxed max-w-3xl">
          Bancoorp actúa como intermediario y no otorga directamente los
          créditos. El destino del crédito, montos y plazos dependerán de la
          evaluación y políticas de cada entidad financiera.
        </p>
      </div>
    </section>
  );
}
